import { useWindowSize } from "../hooks/useWindowSize";

export const MainText = () => {
  const { width } = useWindowSize();

  const imageSrc =
    width < 800 ? "./images/main-mobile.png" : "./images/main-web.png";

  return (
    <img
      src={imageSrc}
      alt="main-text"
      style={{
        marginTop: "24px",
      }}
    />
  );
};
